<template>
  <div class="space-y-6">
    <div class="space-y-2">
      <h2 class="text-lg font-medium text-background-fg/87">
        Summary
      </h2>
      <MerchantGroupDashboardReportSummary />
    </div>
    <div class="grid grid-cols-1 gap-2 lg:grid-cols-2">
      <div class="flex flex-col">
        <h2
          class="mb-2 shrink-0 text-lg font-medium text-background-fg/87"
        >
          Revenue
        </h2>

        <BaseCard class="relative h-full">
          <MerchantGroupDashboardTransactionChart />
        </BaseCard>
      </div>

      <div class="flex flex-col">
        <h2
          class="mb-2 shrink-0 text-lg font-medium text-background-fg/87"
        >
          Latest Transactions
        </h2>
        <BaseCard class="relative h-full">
          <MerchantGroupDashboardTransactionsList />
        </BaseCard>
      </div>
    </div>
    <div class="flex flex-col">
      <div class="mb-2 flex items-baseline justify-between">
        <h2
          class="text-lg font-medium text-background-fg/87"
        >
          Merchants
        </h2>
        <span
          v-if="merchantStatsLastRefreshed"
          class="relative top-1 text-xs text-black/40"
        >
          Merchant stats last refreshed at
          {{ merchantStatsLastRefreshed }}
        </span>
      </div>
      <BaseCard>
        <QueryError
          v-if="isMerchantsError"
          class="min-h-72"
          :show-retry="true"
          @retry="refetchMerchants"
        >
          Failed to retrieve merchants
        </QueryError>
        <MerchantGroupMerchantsTable
          v-else
          :merchants="merchants"
          :is-loading="merchantsLoading"
        />
      </BaseCard>
    </div>
  </div>

  <RouterView #default="{ Component, route }">
    <BaseDialog
      :is-open="!!Component"
      size="lg"
      @close="
        router.push({ name: 'merchantGroupDashboard' })
      "
    >
      <component :is="Component" v-bind="route.params" />
    </BaseDialog>
  </RouterView>
</template>

<script setup lang="ts">
import * as DateFns from "date-fns"

import MerchantGroupDashboardTransactionsList from "@/components/merchantGroup/MerchantGroupDashboardTransactionsList.vue"
import { useMerchantGroupMerchants } from "@/services/merchantGroup/merchants/listMerchantGroupMerchants"

const router = useRouter()

const {
  data: merchantResp,
  isLoading: merchantsLoading,
  isError: isMerchantsError,
  refetch: refetchMerchants,
} = useMerchantGroupMerchants()

const merchants = computed(
  () => merchantResp.value?.merchants ?? []
)

const merchantStatsLastRefreshed = computed(() =>
  merchantResp.value?.lastRefreshed
    ? DateFns.format(
        merchantResp.value.lastRefreshed,
        "HH:mm dd/MM/yyyy"
      )
    : ""
)
</script>
